<script setup lang="ts">
import { computed, useAttrs } from 'vue'
import { NSpin } from 'naive-ui'
import { AppLoading } from '@/components/common'

const attrsSpin = useAttrs()
const attrsSpinDefault = {
  rotate: false,
}
const attrs = computed(() => ({
  ...attrsSpinDefault,
  ...attrsSpin,
}))
</script>

<template>
  <NSpin v-bind="attrs">
    <slot />
    <template #icon>
      <AppLoading />
    </template>
  </NSpin>
</template>

<style scoped>
:deep(.n-spin) {
  height: auto;
  width: 64px;
}
:deep(.n-spin-content) {
  background-color: transparent;
}
</style>
